export enum ExpenseApprovalStatus {
    PENDING         = 0,
    APPROVED        = 1,
    REJECTED        = 2
}


export enum ExpenseSystemType {
    AMOUNT  = 1,        // amount based
    UNIT    = 2         // unit based
}

export enum ExpenseReimbursementStatus {
    NOT_REIMBURSABLE = 0,
    PENDING          = 1,
    REIMBURSED       = 2,
    REJECTED         = 3,   // not in use

}